<script setup lang="ts">
import {onBeforeMount} from "vue";
import {bt, loadBT, loading, queryParams} from "@/store/bt";
import BTTable from "@/bt/BTTable.vue";
import SpinnerIcon from "@/icons/SpinnerIcon.vue";

const nid = (window as any).drupalSettings?.matrixNodeId || document.querySelector('article')?.getAttribute('data-history-node-id') as string
const article = document.querySelector('article') as HTMLElement

const tables = [203, 211, 205]

onBeforeMount(async () => {
  const mountDiv = document.querySelector('#vue-bt') as HTMLElement
  mountDiv.style.maxWidth = `${article.clientWidth}px`
  await loadBT(nid, queryParams);
})
</script>

<template>
  <div v-if="loading">
    <div class="bt__loader">
      <SpinnerIcon/>
    </div>
  </div>
  <template v-if="!loading && bt">
    <template v-for="catId in tables" :key="catId">
      <div class="table-wrapper">
        <BTTable :cat-id="catId" :one-row-id="parseInt(nid)"/>
      </div>
    </template>
  </template>
</template>

<style>
table.onerow {
  thead.bt__thead {
    /** No sticky header for multi display */
    position: static;
  }
}
</style>

<style scoped>
.bt__loader {
  display: grid;
  place-items: center;
  min-height: 500px;
}

.table-wrapper {
  max-width: 100%;
  overflow-x: scroll;
}
</style>
